import React from 'react';
import Greeting from './Greeting';
import './Hero.css';

const Hero = () => {
  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-full">
      <div className="hero-overlay">
        <div className="hero-content-wrapper">
          {/* Text Column */}
          <div className="hero-text-col">
            <Greeting />
            <h1 className="main-title">Rabin Pandey</h1>
            <p className="tagline">CREATIVE DEVELOPER & AI ENTHUSIAST</p>
            <p className="description">
              Originally from Nepal, I'm currently pursuing my bachelor's degree in Computer Science and Engineering at Nepal Engineering College, Bhaktapur. I'm deeply interested in machine learning, deep learning, and building innovative web solutions.
            </p>
            <button className="watch-portfolio" onClick={scrollToProjects}>
              WATCH PORTFOLIO
            </button>
          </div>

          {/* Image Column */}
          <div className="hero-image-col">
            <div className="hero-image-frame">
              <img src="/my_photo.jpg" alt="Rabin Pandey" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;